import Container from "../../../../common/Container";
import Carousel from "../../../../common/Carousel";
import notificationService from "../../../../../services/NotificationService";
import LoadingDisplay from "../../../../common/LoadingDisplay/LoadingDisplay";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const MostRecentMemeContainerElement = ({
    mostRecentMemes,
    currentImageDisplay,
    setCurrentImageDisplay,
    deleteMostRecentMeme,
}) => {
    const { t } = useTranslation("dashboard");
    const [isLoading, setIsLoading] = useState(false);
    // item.thumbnailUrl might be undefined on beta !

    //remove selected most recent meme
    const removeMostRecentMeme = async (item) => {
        if (!item.id)
            notificationService.setMessage(t("mostRecentMemeRemovingFailed"));

        setIsLoading(true);

        const isDeleted = await deleteMostRecentMeme(item);

        setIsLoading(false);

        if (!isDeleted) return;

        notificationService.setTitle(t("mostRecentMemeDeleteTitle"));
        const deleteMessage = item.displayName
            ? t("mostRecentMemeDeletedWithDisplayName", {
                  displayName: item.displayName,
              })
            : t("mostRecentMemeDeletedDefault");
        notificationService.setMessage(deleteMessage);
    };

    const mostRecentMemeQuestion = (item) => {
        notificationService.setMessage(
            t("mostRecentMemeremoveOrDownloadMeme", {
                displayName: item.displayName,
            }),
        );
        notificationService.setTitle(t("mostRecentMemeRemoveOrDownloadTitle"));
        notificationService.setImage(
            item.thumbnailUrl ? item.thumbnailUrl : item.url,
        );

        //delete
        notificationService.setButtonText(t("deleteButton"));
        notificationService.onClick(() => {
            //reset the window
            notificationService.clearAll();
            removeMostRecentMeme(item);
        });

        // download
        notificationService.setButtonText2(t("downloadButton"));
        notificationService.onClick2(() => {
            //reset the window
            notificationService.clearAll();
            window.open(item.url, "Download");
        });
    };

    let currentDisplayName = mostRecentMemes[currentImageDisplay]
        ? mostRecentMemes[currentImageDisplay].displayName
        : null;
    let currentItemPrice = mostRecentMemes[currentImageDisplay]
        ? mostRecentMemes[currentImageDisplay].price
        : null;
    let currentImage = mostRecentMemes[currentImageDisplay];

    const fromText = currentDisplayName
        ? `${t("mostRecentMemesFromText")}`
        : "";
    const displayName = currentDisplayName
        ? currentDisplayName.toUpperCase()
        : "";
    const priceText =
        currentItemPrice !== "0" && currentItemPrice
            ? `${t("mostRecentMemesPriceText")}`
            : "";
    const itemPrice =
        currentItemPrice !== "0" && currentItemPrice
            ? currentItemPrice + " Bits"
            : "";

    let textToDisplayBelow = t("mostRecentMemesItemDetails", {
        fromText,
        displayName,
        priceText,
        itemPrice,
    });

    const onClickFocusImage = () => mostRecentMemeQuestion(currentImage);

    let content = (
        <>
            <br />
            <br />
            <div className="mostRecentMemesContainerGlobal">
                <Container
                    isNoBackground={true}
                    maxWidth={"auto"}
                    content={
                        <>
                            <Carousel
                                items={mostRecentMemes}
                                title={t("mostRecentMemesTitle")}
                                currentlyDisplayedIndex={currentImageDisplay}
                                noItemWasFoundText={t("mostRecentMemesNoMemes")}
                                noItemDescriptionText={t(
                                    "mostRecentMemesDescription",
                                )}
                                setCurrentlyDisplayedIndex={
                                    setCurrentImageDisplay
                                }
                                textBelowCarousel={textToDisplayBelow}
                                OnClickFocusImage={onClickFocusImage}
                            />
                        </>
                    }
                />
            </div>
        </>
    );

    return isLoading ? <LoadingDisplay /> : content;
};

export default MostRecentMemeContainerElement;
